import React from 'react';
import { Droppable, DroppableProvided, DroppableStateSnapshot } from 'react-beautiful-dnd';

function DropOverlay({
  provided,
  snapshot,
}: {
  provided: DroppableProvided;
  snapshot: DroppableStateSnapshot;
}) {
  return (
    <div
      ref={provided.innerRef}
      {...provided.droppableProps}
      className={`create-seat-drop-overlay${snapshot.isDraggingOver ? ' dragging-over' : ''}`}
    >
      {provided.placeholder}
    </div>
  );
}

interface AddTurfToCrewDropZoneProps {
  crewId: number;
}

export default function AddTurfToCrewDropZone({ crewId }: AddTurfToCrewDropZoneProps) {
  return (
    <div id={`add-turf-drop-mat-${crewId}`} className="add-turf-drop-mat add-seat-drop-mat visible">
      <div className="drop-text">+ Drop turf to add a seat to this crew</div>
      <Droppable droppableId={`create-seat-turf_${crewId}`} type="TURF">
        {(provided, snapshot) => <DropOverlay provided={provided} snapshot={snapshot} />}
      </Droppable>
    </div>
  );
}
